import { useContext } from "react";
import { OnDemandTutoringContext } from "../context/ondemandtutoring.provider";

const useOnDemandTutoring = () => {
  // get the context
  const context = useContext(OnDemandTutoringContext);

  const {
    visible,
    enabled,
    available,
    showNudge,
    areTeachersAvailable,
    setVisible,
    setEnabled,
    setAvailable,
    setShowNudge,
    closeNudge
  } = context;

  return {
    visible,
    enabled,
    available,
    showNudge,
    areTeachersAvailable,
    setVisible,
    setEnabled,
    setAvailable,
    setShowNudge,
    closeNudge
  };
};

export default useOnDemandTutoring;
